<template>
  <div class="main-menu menu-fixed menu-light menu-accordion menu-shadow expanded custom-bg" data-scroll-to-active="true">
    <div class="navbar-header expanded">
      <ul class="nav navbar-nav flex-row">
        <li class="nav-item me-auto">
          <SidebarLoader v-if="loading" class="mt-2" />
          <div v-else @click="goToCompany" style="cursor:pointer" class="d-flex align-items-center">
            <img v-if="selectedModules && selectedModules.icon" class="mt-1 me-2" width="40" :src="selectedModules.icon" alt="">
            <p class="mb-0 mt-1">{{ selectedModules ? selectedModules.name : '' }}</p>
          </div>
        </li>
        <li class="nav-item nav-toggle">
          <a class="nav-link modern-nav-toggle pe-0" data-bs-toggle="collapse">
            <i class="d-block d-xl-none text-primary toggle-icon font-medium-4" data-feather="arrow-left"></i>
            <i class="d-none d-xl-block collapse-toggle-icon font-medium-4 text-primary" data-feather="arrow-left"></i>
          </a>
        </li>
      </ul>
    </div>
    <div class="main-menu-content">
      <ul class="navigation navigation-main" id="main-menu-navigation" data-menu="menu-navigation">
        <li class="navigation-header">
          <span>Menus</span>
        </li>
        
        <div class="px-2" v-if="loading">
          <SidebarLoader v-for="n in 10" :key="n" />
        </div>
        
        <template v-else>
          <template v-for="(item, i) in sidebar" :key="i">
            <li v-if="item.status == 'active'" 
                class="nav-item" 
                :class="{ 
                  'has-sub': !getDirectPage(item) && item.submenus && item.submenus.length > 0 && !item.is_dashboard,
                  'open': !getDirectPage(item) && openMenuId === item.id && !item.is_dashboard,
                  'sidebar-group-active': !getDirectPage(item) && (openMenuId === item.id || item.id == $route.params.menuId) && !item.is_dashboard,
                  'active': item.id == $route.params.menuId && (item.is_dashboard || !item.submenus || item.submenus.length === 0 || getDirectPage(item))
                }"
            >
              <a v-if="!getDirectPage(item) && item.submenus && item.submenus.length > 0 && !item.is_dashboard" 
                 @click.prevent.stop="toggleMenu(item)" 
                 class="d-flex align-items-center"
                 style="cursor: pointer"
              >
                <img :src="item.is_dashboard ? '/app-assets/images/icons/dashboard.jpeg' : item.icon" width="25" alt="" class="me-1">
                <span class="menu-title text-truncate">{{ item.name }}</span>
                <span class="menu-arrow">
                  <img :src="openMenuId === item.id ? '/app-assets/images/icons/layout/chevron-down.svg' : '/app-assets/images/icons/layout/chevron-right.svg'" width="14" alt="">
                </span>
              </a>
              <a v-else-if="getDirectPage(item)"
                 @click.prevent.stop="goToPage(getDirectPage(item), item.id)"
                 class="d-flex align-items-center"
                 style="cursor: pointer"
              >
                <img :src="item.is_dashboard ? '/app-assets/images/icons/dashboard.jpeg' : item.icon" width="25" alt="" class="me-1">
                <span class="menu-title text-truncate">{{ item.name }}</span>
              </a>
              <router-link v-else
                :to="{ name: 'CompanySubmenu', params: { menuId: item.id } }"
                @click="handleClick"
                class="d-flex align-items-center"
              >
                <img :src="item.is_dashboard ? '/app-assets/images/icons/dashboard.jpeg' : item.icon" width="25" alt="" class="me-1">
                <span class="menu-title text-truncate">{{ item.name }}</span>
              </router-link>

              <ul class="menu-content" v-if="!getDirectPage(item) && item.submenus && item.submenus.length > 0 && !item.is_dashboard">
                <li v-for="submenu in item.submenus" :key="submenu.id"
                    class="nav-item"
                    :class="{
                      'has-sub': submenu.pages && submenu.pages.length > 0,
                      'open': openSubmenuId === submenu.id,
                      'sidebar-group-active': openSubmenuId === submenu.id
                    }"
                >
                  <a v-if="submenu.pages && submenu.pages.length > 0" 
                     @click.prevent.stop="toggleSubmenu(submenu)" 
                     class="d-flex align-items-center ps-2"
                     style="cursor: pointer"
                  >
                    <i data-feather="circle" class="me-1" style="width: 10px;"></i>
                    <span class="menu-item text-truncate">{{ submenu.name }}</span>
                    <span class="submenu-arrow">
                      <img :src="openSubmenuId === submenu.id ? '/app-assets/images/icons/layout/chevron-down.svg' : '/app-assets/images/icons/layout/chevron-right.svg'" width="12" alt="">
                    </span>
                  </a>
                  <router-link v-else
                    :to="{ name: 'CompanySubmenu', params: { menuId: item.id } }"
                    @click="handleClick"
                    class="d-flex align-items-center ps-2"
                  >
                    <i data-feather="circle" class="me-1" style="width: 10px;"></i>
                    <span class="menu-item text-truncate">{{ submenu.name }}</span>
                  </router-link>

                  <ul class="menu-content" v-if="submenu.pages && submenu.pages.length > 0">
                    <li v-for="page in submenu.pages" :key="page.id">
                      <a :href="'#'"
                         @click.prevent="goToPage(page, item.id)"
                         class="d-flex align-items-center ps-3"
                         :class="{ 'active': $route.params.pageId == page.id }"
                         style="cursor: pointer"
                      >
                        <i data-feather="circle" class="me-1" style="width: 8px;"></i>
                        <span class="menu-item text-truncate">{{ page.name }}</span>
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </template>
        </template>
      </ul>
    </div>
  </div>
</template>

<script>
import {menu} from '@/data/menu'
import {mapGetters} from 'vuex'
import SidebarLoader from "@/components/atom/loader/SidebarLoader.vue";
import { getPageRouterPayload } from "@/services/utils/navigation";

export default {
  name: 'SideNavbar',

  components: {
    SidebarLoader
  },

  data: () => ({
    menu,
    openMenuId: null,
    openSubmenuId: null
  }),

  computed: {
    ...mapGetters({
      sidebar: 'company/getSidebar',
      companyLogo: 'company/getCompanyLogo',
      modules: 'company/getModules'
    }),
    moduleId() {
      return parseInt(this.$route.params.moduleId)
    },
    companyId() {
      return this.$route.params.companyId
    },
    selectedModules() {
      return this.modules.find(module => module.id == this.moduleId)
    }
  },

  watch: {
    '$route': {
      immediate: true,
      handler(route, oldRoute) {
        const isNewMenu = !oldRoute || route.params.menuId !== oldRoute.params.menuId;
        const isNewPage = !oldRoute || route.params.pageId !== oldRoute.params.pageId;

        if (!isNewMenu && !isNewPage) return;
        
        if (route.params.menuId) {
          this.openMenuId = parseInt(route.params.menuId);
        }
        this.autoExpandSidebar();
      }
    },
    sidebar: {
      immediate: true,
      handler() {
        this.autoExpandSidebar();
      }
    }
  },

  methods: {
    toggleMenu(item) {
      if (this.openMenuId === item.id) {
        this.openMenuId = null;
        return;
      }
      
      this.openMenuId = item.id;
      if (item.is_dashboard) {
        this.$router.push({
          name: 'CompanySubmenu',
          params: { menuId: item.id }
        });
      }
    },

    getDirectPage(item) {
      if (item.is_dashboard) return null;
      const activeSubmenus = (item.submenus || []).filter(s => s.status === 'active');
      if (activeSubmenus.length !== 1) return null;
      
      const activePages = (activeSubmenus[0].pages || []).filter(p => p.status === 'active');
      if (activePages.length !== 1) return null;
      
      return activePages[0];
    },

    toggleSubmenu(submenu) {
      if (this.openSubmenuId === submenu.id) {
        this.openSubmenuId = null;
        return;
      }
      this.openSubmenuId = submenu.id;
    },

    autoExpandSidebar() {
      if (!this.sidebar || !this.$route.params.pageId) return;
      
      const pageId = this.$route.params.pageId;
      for (const item of this.sidebar) {
        if (item.is_dashboard || !item.submenus) continue;
        
        for (const sub of item.submenus) {
          if (!sub.pages) continue;
          
          if (sub.pages.find(p => p.id == pageId)) {
            this.openMenuId = item.id;
            this.openSubmenuId = sub.id;
            return;
          }
        }
      }
    },

    goToCompany() {
      this.$router.push({
        name: 'Company',
        params: {
          companyId: this.companyId,
          moduleId: this.moduleId
        }
      })
    },

    handleClick() {
      let width = document.body.clientWidth;
      if (width > 1199) return;
      
      const btn = document.querySelector('.modern-nav-toggle');
      if (btn) btn.click();
    },

    goToPage(page, menuId) {
      if (!page.route) return;
      
      this.handleClick();

      const payload = getPageRouterPayload(page, {
        companyId: this.companyId,
        moduleId: this.moduleId,
        menuId: menuId
      });

      this.$router.push(payload);
    }
  },

  props: {
    loading: Boolean
  }
}
</script>

<style scoped>
.main-menu-content {
  overflow-y: auto;
  overflow-x: hidden;
}

.main-menu-content::-webkit-scrollbar {
  width: 4px;
}

.main-menu-content::-webkit-scrollbar-thumb {
  background: #dbdbdb;
  border-radius: 10px;
}

.navigation-main {
  padding: 0 5px 30px 5px;
}

.navigation-main .nav-item a {
  border-radius: 8px;
  margin: 4px 0;
  padding: 10px 8px;
  transition: all 0.2s ease;
  color: #4b4b4b;
}

.menu-arrow img, .submenu-arrow img {
  margin-left: 10px;
}

.navigation-main .nav-item.active > a,
.navigation-main .nav-item .menu-content li a.active {
  background: #f0f0f0 !important;
  color: #2b2b2b !important;
  box-shadow: none !important;
  font-weight: 600;
}

.navigation-main .nav-item.open > a,
.navigation-main .nav-item.sidebar-group-active > a {
  background: transparent !important;
  box-shadow: none !important;
  color: #2b2b2b;
}

.navigation-main .nav-item a:hover {
  background-color: #f0f0f0;
}

.menu-arrow, .submenu-arrow {
  margin-left: auto;
  display: flex;
  align-items: center;
  color: #828282;
}

.navigation-main .nav-item.has-sub > a:after {
  display: none !important;
}

.navigation-main .nav-item .menu-content {
  padding: 0;
  margin: 0;
  list-style: none;
  background: transparent;
}

.navigation-main .nav-item.has-sub.open > .menu-content {
  display: block !important;
}

.navigation-main .nav-item.has-sub:not(.open) > .menu-content {
  display: none !important;
}

.main-menu.menu-light .navigation > li ul .active,
.main-menu.menu-light .navigation > li.active > a {
  background: #f0f0f0 !important;
  box-shadow: none !important;
  color: #2b2b2b !important;
  font-weight: 600 !important;
}

.main-menu.menu-light .navigation > li > a {
  margin: 0px !important;
}

.navigation-main .nav-item .menu-content a {
  font-size: 14px !important;
}
</style>
